package fr.frux.feature.harvestdetail

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/**
 * Contrat de fabrique du [HarvestDetailViewModel], honoré par le composition root (#43).
 *
 * `harvestId` vient de la route, pas du graphe : c'est le seul paramètre que l'appelant fournit.
 */
fun interface HarvestDetailViewModelFactory {
    fun create(harvestId: Long): HarvestDetailViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalHarvestDetailViewModelFactory = staticCompositionLocalOf<HarvestDetailViewModelFactory> {
    error("HarvestDetailViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
}

/** Fabrique le HarvestDetailViewModel depuis la fabrique fournie par le root. */
@Composable
fun rememberHarvestDetailViewModel(harvestId: Long): HarvestDetailViewModel {
    val factory = LocalHarvestDetailViewModelFactory.current
    return viewModel { factory.create(harvestId) }
}
